import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ConfigData {
  [key: string]: any;
}

interface ConfigState {
  // State
  config: ConfigData;
  isLoading: boolean;
  error: string | null;
  lastUpdated: number | null;

  // Actions
  setConfig: (config: ConfigData) => void;
  updateConfig: (key: string, value: any) => void;
  getConfigValue: (key: string, defaultValue?: any) => any;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearConfig: () => void;
  hasConfig: () => boolean;
}

export const useConfigStore = create<ConfigState>()(
  persist(
    (set, get) => ({
      // Initial state
      config: {},
      isLoading: false,
      error: null,
      lastUpdated: null,

      // Actions
      setConfig: (config) => {
        set({
          config,
          error: null,
          lastUpdated: Date.now(),
        });
      },

      updateConfig: (key, value) => {
        set((state) => ({
          config: {
            ...state.config,
            [key]: value,
          },
          lastUpdated: Date.now(),
        }));
      },

      getConfigValue: (key, defaultValue) => {
        const { config } = get();
        return config[key] !== undefined ? config[key] : defaultValue;
      },

      setLoading: (loading) => {
        set({ isLoading: loading });
      },

      setError: (error) => {
        set({ error, isLoading: false });
      },

      clearConfig: () => {
        set({
          config: {},
          error: null,
          lastUpdated: null,
        });
      },

      hasConfig: () => {
        const { config } = get();
        return Object.keys(config).length > 0;
      },
    }),
    {
      name: 'config-storage',
      partialize: (state) => ({
        config: state.config,
        lastUpdated: state.lastUpdated,
      }),
    },
  ),
);
